module.exports = __webpack_public_path__ + "img/b2021.8d39bffa.jpg";